import { gql } from 'apollo-angular';

export const userListQuery = gql`
  query UserList {
    userList {
      id
      name
      lastName
      imgUrl
      email
      propertyIds
      role
      phone
      commissionerEndDate
      commissionerPermissions {
        key
        value {
          viewer
          editing
        }
      }
    }
  }
`;

export const userSelectOptionsQuery = gql`
  query UserSelectOptions {
    userList {
      id
      name
      lastName
      role
    }
  }
`;

export const createUserMutation = gql`
  mutation CreateUser(
    $name: String!
    $lastName: String!
    $email: String!
    $role: ROLES!
    $propertyIds: [ID!]!
    $commissionerEndDate: AWSDateTime
    $commissionerPermissions: [PermissionsInput]
  ) {
    createUser(
      name: $name
      lastName: $lastName
      email: $email
      role: $role
      propertyIds: $propertyIds
      commissionerEndDate: $commissionerEndDate
      commissionerPermissions: $commissionerPermissions
    ) {
      id
      name
      lastName
      propertyIds
      email
      role
    }
  }
`;

export const updateUserMutation = gql`
  mutation UpdateUser($user: UserInput!) {
    updateUser(user: $user) {
      id
      name
      lastName
      propertyIds
      email
      role
    }
  }
`;

export const deleteUsersMutation = gql`
  mutation DeleteUsers($ids: [ID!]!) {
    deleteUsers(ids: $ids) {
      id
      name
      lastName
      email
      role
    }
  }
`;

export const canDeleteUserQuery = gql`
  query CanDeleteUser($userId: ID!) {
    canDeleteUser(userId: $userId) {
      canDelete
      reason
    }
  }
`;

export const canCreateUserQuery = gql`
  query CanCreateUser($email: String!) {
    canCreateUser(email: $email) {
      canCreate
      reason
    }
  }
`;

export const getUserRoleQuery = gql`
  query GetUserRole {
    getUserRole
  }
`;

export const getPermissionsQuery = gql`
  query GetPermissions($role: ROLES!) {
    getPermissions(role: $role) {
      key
      value {
        viewer
        editing
      }
    }
  }
`;

export const getUserLogs = gql`
  query GetUserLogs( $pageSize: Int!, $cursor: String, $filters: UserLogsFilters) {
    getUserLogs(pageSize: $pageSize, cursor: $cursor, filters: $filters) {
      data {
        id
        dateTime
        user {
          email
        }
        action
        object
        description
      }
      nextCursor
      hasMore
      totalItems
    }
  }
`;

export const userLogsExport = gql`
  query UserLogsExport($filters: UserLogsFilters) {
    userLogsExport(filters: $filters) {
      id
      filename
      contentType
      size
      content
      __typename
    }
  }
`;

export const resetPassword = gql`
  mutation ResetPassword {
    resetPassword
  }
`;

export const registerLogin = gql`
  mutation RegisterLogin {
    registerLogin
  }
`;

export const registerLogout = gql`
  mutation RegisterLogout {
    registerLogout
  }
`;
